import { render } from "./ContactViewClient.vue?vue&type=template&id=5190ad4e"
import script from "./ContactViewClient.vue?vue&type=script&lang=js"
export * from "./ContactViewClient.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__